<template>
  <div ref="domRef" :class="['base-card-info', 'min-h-[250px]', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      开户许可证信息
    </div>
    <div class="custom-base-info">
      <div class="item" style="z-index: 2;">
        <div class="label">
          银行开户许可证
        </div>
        <div class="value h-[0]">
          <div class="business-license-box">
            <img
              :src="baseInfo.companyLicense?.licenseUrl"
            >
          </div>
        </div>
      </div>
      <div class="item">
        <div class="label">
          对公账户名
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.accountName }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          银行预留手机号
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.phoneNo }}
        </div>
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div class="item">
        <div class="label">
          纳税人识别号
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.creditCode }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          开户银行
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.bankName }}
        </div>
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div class="item">
        <div class="label">
          开票地址
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.address }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          银行账号
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.bankAccount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ICompanyMergeInfo } from '@core/main/types';
import { useElementImgPreview } from '@vue3/components';
import { inject, ref } from 'vue';

defineOptions({ name: 'LicenceInfo' }); // 账户中心 - 开户许可证信息

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

const baseInfo = inject('baseInfo') as ICompanyMergeInfo;
</script>
